export function useTranslatorLocale() {
  const localeCode = ref('');

  const route = useRoute();
  let path = (route as any)?.currentRoute?.path;
  if (!path) {
    path = (route as any)?.path;
  }
  const parts = path ? path.split('/') : [];

  localeCode.value =
    parts.length < 2 || parts[1].length !== 2 ? 'en' : parts[1];

  return {
    locale: localeCode,
  };
}
